import { cn } from "@/lib/utils";
import "./rc.css";

const BODY = "M62 24 C88 16 152 16 178 24 C204 32 220 58 230 98 C238 128 224 146 206 140 C192 135 182 118 166 110 L74 110 C58 118 48 135 34 140 C16 146 2 128 10 98 C20 58 36 32 62 24 Z";
const ARROWS = { up: "M0 -29 L-5 -23 L5 -23 Z", down: "M0 29 L-5 23 L5 23 Z", left: "M-29 0 L-23 -5 L-23 5 Z", right: "M29 0 L23 -5 L23 5 Z" };
const AXIS_ARROWS = { y: ["up", "down"], x: ["left", "right"], both: ["up", "down", "left", "right"] };
const SHOULDERS = { LT: [54, -2, 34, 14, 8], RT: [152, -2, 34, 14, 8], LB: [44, 10, 56, 13, 19.5], RB: [140, 10, 56, 13, 19.5] };
const FACE = { Y: [172, 46], X: [160, 58], B: [184, 58], A: [172, 70] };
const DPAD = { UP: [95.5, 82, 5, 8], DOWN: [95.5, 94.5, 5, 8], LEFT: [88, 89.5, 8, 5], RIGHT: [100.5, 89.5, 8, 5] };

const markClass = (mark) => (mark ? `rc-mark-${mark}` : "rc-pad-button");

const Stick = ({ x, y, role }) => (
  <g transform={`translate(${x} ${y})`} className={cn("rc-stick", role && "is-on")}>
    <circle r="17" className="rc-stick-well" />
    {role && AXIS_ARROWS[role.axes].map((a) => <path key={a} d={ARROWS[a]} className="rc-stick-arrow" />)}
    <circle r="10" className={cn("rc-knob", role && `rc-knob-${role.axes}`)} />
  </g>
);

// Simplified Xbox controller: highlights the sticks used and, optionally, marked buttons ("pos" / "neg").
export const ControllerDiagram = ({ roles = {}, marks = {}, className }) => (
  <svg viewBox="0 -4 240 154" className={cn("overflow-visible", className)} role="img" aria-label="Xbox controller with the controls used highlighted">
    {Object.entries(SHOULDERS).map(([b, [x, y, w, h, ty]]) => (
      <g key={b} data-mark={marks[b] || undefined}>
        <rect x={x} y={y} width={w} height={h} rx="5" className={markClass(marks[b])} />
        <text x={x + w / 2} y={ty} textAnchor="middle" className={cn("rc-pad-label", marks[b] && "is-marked")}>{b}</text>
      </g>
    ))}
    <path d={BODY} className="rc-pad" />
    <circle cx="120" cy="40" r="7" className="rc-pad-button" />
    <rect x="95.5" y="89.5" width="5" height="5" className="rc-pad-button" />
    {Object.entries(DPAD).map(([b, [x, y, w, h]]) => <rect key={b} x={x} y={y} width={w} height={h} rx="1.5" className={markClass(marks[b])} />)}
    {Object.entries(FACE).map(([b, [cx, cy]]) => (
      <g key={b}>
        <circle cx={cx} cy={cy} r="6" className={markClass(marks[b])} />
        <text x={cx} y={cy + 2.4} textAnchor="middle" className={cn("rc-pad-label", marks[b] && "is-marked")}>{b}</text>
      </g>
    ))}
    <Stick x={72} y={60} role={roles.left} />
    <Stick x={150} y={92} role={roles.right} />
  </svg>
);
